var map = {
	"./ANGRY.svg": "b341",
	"./CALM.svg": "bfb1",
	"./CONFUSED.svg": "d98d",
	"./DISGUSTED.svg": "5062",
	"./HAPPY.svg": "ed80",
	"./SAD.svg": "a5bd",
	"./SURPRISED.svg": "5984",
	"./UNKNOWN.svg": "3a91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "25e8";